import { Canvas, ElementTreeJson } from '@thive/canvas';
import { FleetTrackerClient } from '@thive/fleettracker.client';
import { create } from 'zustand';
import { SelectedElement } from '../types';

interface FleetTrackerCanvasStore {
  canvasRef: Canvas | undefined;
  fleetTrackerRef: FleetTrackerClient | undefined;
  isConnected: boolean;
  sessionId: string | undefined;
  selectedElements: SelectedElement[];
  objectTree: ElementTreeJson | undefined;
}

interface FleetTrackerCanvasAction {
  disposeRef: () => void;
  setCanvasRef: (ref: Canvas) => void;
  setFleetTrackerRef: (ref: FleetTrackerClient) => void;
  setIsConnected: (isConnected: boolean) => void;
  setSessionId: (sessionId: string) => void;
  setSelectedElements: (selectedElementIds: SelectedElement[]) => void;
  setObjectTree: (objectTree: ElementTreeJson) => void;
}

const initialState: FleetTrackerCanvasStore = {
  canvasRef: undefined,
  fleetTrackerRef: undefined,
  isConnected: false,
  sessionId: undefined,
  selectedElements: [],
  objectTree: undefined,
};

// NOTE: no devtools for this store. Redux devtools not suited for canvas instance

export const useFleetTrackerCanvasStore = create<
  FleetTrackerCanvasStore & FleetTrackerCanvasAction
>()((set) => ({
  ...initialState,
  disposeRef: () =>
    set((state) => {
      state.canvasRef?.dispose();
      state.fleetTrackerRef?.dispose();
      return { ...initialState };
    }),
  setCanvasRef: (canvasRef: Canvas) => set(() => ({ canvasRef })),
  setFleetTrackerRef: (fleetTrackerRef: FleetTrackerClient) => set(() => ({ fleetTrackerRef })),
  setIsConnected: (isConnected: boolean) =>
    set((state) => {
      let { sessionId } = state;
      if (!isConnected) sessionId = undefined;
      return { isConnected, sessionId };
    }),
  setSessionId: (sessionId: string) => set(() => ({ sessionId })),
  setSelectedElements: (selectedElements: SelectedElement[]) =>
    set(() => ({
      selectedElements: [...selectedElements],
    })),
  setObjectTree: (objectTree: ElementTreeJson) => set(() => ({ objectTree })),
}));
